export enum CCOfflineTransactionStatus {
  /** a newly created offline transaction that has not been synced */
  Unsynced = "unsynced",

  /** we are in the process of syncing the offline transaction */
  Syncing = "syncing",

  /** an error occured during the sync of this transaction so it is not in an errored status */
  Error = "error",

  /** transaction was skipping in sync for a related transaction failed to sync */
  Skipped = "skipped",

  /** a user can chose to ignore this offline transaction */
  Ignored = "ignored",

  /** the transaction has been synced */
  Synced = "synced",
}

export const CCOfflineTransactionStatusDefaultValue = CCOfflineTransactionStatus.Unsynced;
